import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Observable } from 'rxjs';
import { NetworkService } from '../services/network.service';

@Injectable({
  providedIn: 'root'
})
export class IndexedDbService {
  private storeName = 'DbSonEspaceSante';  // Nom du store défini dans `db.config.ts`
  private currentAvailableId: number = -1;

  constructor(
    private dbService: NgxIndexedDBService, 
    private networkService: NetworkService) {}

  // 📌 Ajouter un objet
  addItem(item: any): Observable<any> {
    if(!item['obj'].id) {
      item['obj'].id = this.currentAvailableId;
      this.currentAvailableId -= 1;
    }
    item['time'] = new Date();

    return this.dbService.add(this.storeName, item);
  }

  // 📌 Récupérer un objet par son ID
  getItem(id: number): Observable<any> {
    return this.dbService.getByKey(this.storeName, id);
  }

  // 📌 Récupérer tous les objets
  getAllItems(): Observable<any[]> {
    return this.dbService.getAll(this.storeName);
  }

  // 📌 Mettre à jour un objet
  updateItem(item: any): Observable<any> {
    return this.dbService.update(this.storeName, item);
  }

  // 📌 Supprimer un objet
  deleteItem(id: number): Observable<any> {
    return this.dbService.delete(this.storeName, id);
  }

  // 📌 Supprimer tous les objets
  clearStore(): Observable<void> {
    return this.dbService.clear(this.storeName);
  }

  syncOfflineData(): void {
    this.networkService.isOnline().subscribe(isOnline => {
      if (isOnline) {
        this.getAllItems().subscribe(localData => {
          localData.forEach(data => {
            console.log('syncOfflineData')
            ///this.http.post(this.apiUrl, data).subscribe(() => {
            //  this.indexedDbService.deleteItem(data.id).subscribe();
            //});
          });
        });
      }
    });
  }
}